function createErrorHandler(fieldError, fieldName, setFieldError) {
    return function (error) {
        if (error !== fieldError && error !== '') {
            setFieldError(fieldName, error ? String(error) : undefined);
        }
    };
}

export { createErrorHandler };
//# sourceMappingURL=errorHandler.js.map
